module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-bottom-stone-path-remnants.9489bdba.png";